export default __webpack_public_path__ + "blog-posts-list.png";